import { render, staticRenderFns } from "./CadastroEmMassa.vue?vue&type=template&id=75544dc3&scoped=true"
import script from "./CadastroEmMassa.vue?vue&type=script&lang=js"
export * from "./CadastroEmMassa.vue?vue&type=script&lang=js"
import style0 from "./CadastroEmMassa.vue?vue&type=style&index=0&id=75544dc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75544dc3",
  null
  
)

export default component.exports